import { useEffect, useRef } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';

// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
export default function AuthCallback() {
  const hasProcessed = useRef(false);
  const navigate = useNavigate();
  const location = useLocation();
  const { loginWithGoogleSession } = useAuth();

  useEffect(() => {
    if (hasProcessed.current) return;
    hasProcessed.current = true;
    const params = new URLSearchParams((location.hash || '').replace(/^#/, ''));
    const sessionId = params.get('session_id');
    const run = async () => {
      try {
        if (!sessionId) throw new Error('missing session_id');
        await loginWithGoogleSession(sessionId);
        navigate('/dashboard', { replace: true });
      } catch (e) {
        navigate('/login', { replace: true });
      }
    };
    run();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <div className="min-h-screen flex items-center justify-center bg-[#F8FAFC]" data-testid="auth-callback-loading">
      <div className="flex flex-col items-center gap-3">
        <div className="w-10 h-10 border-4 border-[#2563EB]/20 border-t-[#2563EB] rounded-full animate-spin" />
        <p className="text-sm text-[#64748B] font-semibold">Iniciando sesión con Google...</p>
      </div>
    </div>
  );
}
